import { ReactElement } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DescriptionText } from './../../../../../components/DescrtiptionText';
import { styled } from 'styled-components';
import { blockStyle } from '../../../../../components/styles/Block';

export const ContentHeaderBlock = styled.div`
  ${blockStyle}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

interface Props {
  rowCount: number;
  onAdd: () => void;
  maxRows: number;
}

const ContentHeader = ({ rowCount, onAdd, maxRows }: Props): ReactElement => (
  <ContentHeaderBlock>
    <DescriptionText>最大10人まで同時に登録できます。氏名が入力された顧客のみ登録されます。</DescriptionText>
    <Button type='default' onClick={onAdd} icon={<PlusOutlined />} disabled={rowCount >= maxRows}>
      行を追加
    </Button>
  </ContentHeaderBlock>
);

export default ContentHeader;
